// extracted by mini-css-extract-plugin
export default {"region":"ToastContainer_region__4x9yk"};